import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Content = styled.p`
  margin-bottom: 16px;
`;
export const Badge = styled.p`
  display: inline-flex;
  background-color: #8e4ec6;
  padding: 4px 8px;
  border-radius: 4px;
  gap: 4px;
  justify-content: center;
  align-items: center;
`;

export const BadgeText = styled.span`
  ${typographyV2.uiSm}
`;
